import React from 'react';

import { HeaderPortalContext } from './portal-provider';

const HeaderPortalContainer = ({ headerPortalContext }) => {
  const { children } = headerPortalContext;

  return children && <>{children}</>;
};

export default () => (
  <HeaderPortalContext.Consumer>
    {context =>
      context && (
        <HeaderPortalContainer
          headerPortalContext={context.headerPortalContext}
        />
      )
    }
  </HeaderPortalContext.Consumer>
);
